export default "__VITE_ASSET__BUwQBG3s__"